export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message
  return String(error)
}

export const formatDate = (date: string | null): string => {
  if (!date) return ''
  // Format in UTC so SSR (server zone) and client hydration render the same day.
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  })
}
